import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useEventParticipant } from '../../data/hooks/participant/useEventParticipant';
import resolvePath from '../../misc/resolvePath';
import RelativeRedirect from '../elements/RelativeRedirect/RelativeRedirect';
import LoadEnrichments from '../loaders/LoadEnrichments';
import LoadEventConnections from '../loaders/LoadEventConnections';
import LoadMeetings from '../loaders/LoadMeetings';
import LoadParticipants from '../loaders/LoadParticipants';
import LoadSpeakers from '../loaders/LoadSpeakers';
import EventParticipantProfile from '../screens/EventParticipantProfile';
import EventParticipants from '../screens/EventParticipants';
import EventParticipantsFilterScreen from '../screens/EventParticipants/EventParticipantsFilterScreen';
import SendEmailToContact from '../screens/GlobalContacts/SendEmailToContact';
import InviteToMeetingScreen from '../screens/Meetings/InviteToMeetingScreen';
import chatRoutes from './chatRoutes';
import enrichmentRoutes from './enrichmentRoutes';

export const participantRoutes = (props) => {
    const { eventId, userId, participantId, questionId, path, itemId } = props.match.params,
        participant = useEventParticipant(
            eventId,
            { userId, participantId },
            {
                questionId,
                directoryItemId: path ? path.split('/').pop() : null,
                sessionId: itemId,
            }
        );

    if (!participant) {
        console.log('Participant not found: ', userId, participantId);
        return <RelativeRedirect to=".." />;
    }

    return (
        <Switch>
            <Route path={`${props.match.path}/email`} exact component={SendEmailToContact} />
            <Route path={`${props.match.path}/invite`} exact component={InviteToMeetingScreen} />
            <Route path={`${props.match.path}/enrich`} component={enrichmentRoutes} />
            <Redirect from={`${props.match.path}/chats`} exact to={`${props.match.path}`} />
            <Route path={`${props.match.path}/chats`} component={chatRoutes} />
            <Route path={`${props.match.path}`} exact component={EventParticipantProfile} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    );
};

const CommonLoaders = (props) => (
    <LoadParticipants eventId={props.match.params.eventId}>
        <LoadEventConnections eventId={props.match.params.eventId}>
            <LoadMeetings eventId={props.match.params.eventId}>
                <LoadEnrichments eventId={props.match.params.eventId}>
                    <LoadSpeakers eventId={props.match.params.eventId}>{props.children}</LoadSpeakers>
                </LoadEnrichments>
            </LoadMeetings>
        </LoadEventConnections>
    </LoadParticipants>
);

export const innerParticipantRoutes = (props) => (
    <CommonLoaders {...props}>
        <Switch>
            <Route path={`${props.match.path}/:userId/:participantId`} component={participantRoutes} />
            <Redirect to={resolvePath(props.match.path, '..')} />
        </Switch>
    </CommonLoaders>
);

export default (props) => (
    <CommonLoaders {...props}>
        <Switch>
            <Route path={`${props.match.path}/filter`} exact component={EventParticipantsFilterScreen} />
            <Route path={`${props.match.path}/:userId/:participantId`} component={participantRoutes} />
            <Route path={`${props.match.path}`} exact component={EventParticipants} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    </CommonLoaders>
);
